// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3McuG","amount":"Amount_amount__Eovzt","tip":"Amount_tip__nn6GZ","tipHeader":"Amount_tipHeader__16Zvl","tipsWrap":"Amount_tipsWrap__2kRsa"};